/* app/js/src/components/mediaEditor/files-tab/edit-media-files-tab.component.scss */
.upload-zone .upload-button {
  position: relative;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.upload-zone .upload-button::before {
  content: " ";
  position: absolute;
  left: calc(50% - 6px);
  width: 0;
  height: 0;
  top: -10px;
  background-color: transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid transparent;
  border-top: 5px solid #232f3a;
  opacity: 0;
  -ms-transform: translateY(5px);
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-transition-delay: 0.1s;
  transition-delay: 0.1s;
}
.upload-zone .upload-button::after {
  content: "Upload File";
  background-color: #232f3a;
  position: absolute;
  top: -33px;
  left: calc(50% - 38px);
  width: 70px;
  text-align: center;
  padding: 0.5em;
  color: #fff;
  font-size: 0.7em;
  border-radius: 5px;
  opacity: 0;
  -ms-transform: translateY(5px);
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-transition-delay: 0.1s;
  transition-delay: 0.1s;
}
.upload-zone .upload-button:hover::before,
.upload-zone .upload-button:hover::after {
  opacity: 1;
  -ms-transform: translateY(0);
  -webkit-transform: translateY(0);
  transform: translateY(0);
}
.cursor-pointer {
  cursor: pointer;
}
.row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 15px 5px;
  border: 1px solid transparent;
}
.upload-zone .upload-button {
  margin-right: 16px;
  cursor: pointer;
}
.upload-zone .upload-button:hover ::ng-deep svg path {
  fill: #7d8fa1 !important;
}
.upload-zone.drag {
  border: 1px dashed #7d8fa1;
}
.upload-zone.drag > * {
  pointer-events: none;
}
.label {
  color: #7d8fa1;
  font-size: 13px;
  width: 150px;
  white-space: nowrap;
}
.label i {
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}
.label i ::ng-deep svg {
  width: 19px;
}
.label i ::ng-deep svg path {
  fill: #879baf !important;
}
.label span {
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}
.files {
  display: flex;
  flex-wrap: wrap;
}
.subtitles icn-file-label {
  text-transform: uppercase;
}
.closed-captions .caption-link {
  text-transform: uppercase;
  cursor: pointer;
  margin-right: 12px;
  color: #7d8fa1;
}
.closed-captions .caption-link:hover {
  text-decoration: underline;
}
.closed-captions .empty-hint {
  color: #879baf;
}
.langPopover {
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
}
.langPopover h1 {
  margin: 0px 0px 10px 0px;
}
.lang-flex-container {
  display: flex;
  flex-direction: column;
}
.fps-container,
.lang-container {
  display: flex;
}
.fps-container label,
.lang-container label {
  margin-right: 10px;
  line-height: 27px;
}
/*# sourceMappingURL=edit-media-files-tab.component.css.map */
